import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { OS } from '@hozana/screen/constants'
import { getOs } from '@hozana/screen/functions/getOs'
import { useScreen } from '@hozana/screen/useScreen'
import { cookie } from '@hozana/storage/cookies'

import { QUERY_ACTION } from 'general/constants'
import { COOKIES, COOKIES_CONFIG } from 'general/managers/cookies/constants'
import { POPINS } from 'general/managers/popins/constants'

import { useUser } from 'modules/user/hooks/useUser'

import { PromptType } from './constants'
import { usePromptsManagement } from './usePromptsManagement'

const onPop = () =>
  cookie.save(COOKIES.devHasSeenPopin, true, {
    ...COOKIES_CONFIG.ONE_YEAR,
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
  })

/**
 * ### LinuxPopinManager ###
 */
export const LinuxPopinManager: TFC = () => {
  const {
    i18n: { language },
  } = useTranslation()
  const screen = useScreen()
  const me = useUser()

  const show = useMemo(
    () =>
      __CLIENT__ &&
      getOs() === OS.LINUX &&
      me.name &&
      language === 'fr' &&
      !screen.xs &&
      cookie.load(COOKIES.devHasSeenPopin) === undefined,
    [language, screen.xs, me.name],
  )

  const popinOptions = useMemo(() => ({ userName: me.name }), [me.name])

  usePromptsManagement({
    type: PromptType.LINUX,
    delay: 5000, // 5s
    show: !!show,
    actionKey: QUERY_ACTION.LINUX,
    onPop,
    popinName: POPINS.LinuxDevPopin,
    popinOptions,
  })

  return null
}
